<template>
    <div class="KeywordManagementPage">
        <zPage :contentState="pageContentState">
            <template v-slot:headerTitle>{{ gettext('Управление ключевыми словами') }}</template>
            <template v-slot:headerDescription>{{ gettext('Здесь можно настроить списки ключевых слов, по которым система будет отслеживать позиции карточек вашей компании.') }}
                <a @click="openModal1"
                   class="a-button a-button--link a-button--action">{{ gettext('Подробнее') }}</a>
            </template>

            <template v-slot:topBar>
                <button class="button button--system" v-on:click="goToLocalPackHome"><i class="fa fa-arrow-left"></i>{{ gettext('Вернуться на главную LocalPack') }}</button>
            </template>

            <template v-slot:main>
                <div>
                    <div class="field">
                        <div class="field__title">{{ gettext('Выберите филиал') }}</div>
                        <Select class="field__input" style="width:200px" @on-change="setBranch">
                            <Option v-for="branch in branchesList" :value="branch.id" :key="branch.id">{{ branch.name }}</Option>
                        </Select>
                    </div>

                    <div v-if="chosenBranchTitle" class="field">
                        <div class="field__input">
                            <div style="font-size: 10px; color: #777">{{ gettext('Выбранный филиал') }}</div>
                            <div style="font-size: 16px; font-weight: 700">{{ chosenBranchTitle.name }}</div>
                            <div style="font-size: 12px; color: #777">{{ chosenBranchTitle.address }}</div>
                        </div>
                    </div>

                    <div class="field" :class="!chosenBranchId ? 'disabled' : ''" style="margin-top: 40px">
                        <div class="buttonGroup" style="display: inline-block">
                            <button class="button" @click="() => {setCurrentTab('list'); getKeywordsList()}" v-bind:class="{'--active': currentTab === 'list'}">{{ gettext('Показать фразы') }}
                            </button>
                            <button class="button" @click="setCurrentTab('add')" v-bind:class="{'--active': currentTab === 'add'}">{{ gettext('Добавить фразы') }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="tab-content list" v-if="currentTab === 'list'">
                    <!--                <zPaginator ref="paginator"-->
                    <!--                            v-if="paginator"-->
                    <!--                            :paginator="paginator"-->
                    <!--                            :pending="domains.keywordsList.query.pending"-->
                    <!--                            @changePage="changePage"-->
                    <!--                            @changePageSize="changePageSize">-->
                    <div class="xCard"
                         v-for="keyword in keywordsList" :key="keyword.id">
                        <div class="xCard__body">
                            <div style="display: flex; align-items: baseline;">
                                <div class="__title">{{ keyword.keyword }}</div>
                            </div>
                            <div v-if="!isDemoPage">
                                <button class="a-button a-button--link a-button--grey" @click="(event) => deleteKeyword(event, keyword.keyword)" style="font-size: 12px">{{ gettext('Удалить') }}</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="keywordsList && !keywordsList.length" style="font-size: 14px">
                        {{ gettext('Список пуст - добавьте фразы') }}
                    </div>
                    <!-- </zPaginator> -->
                </div>

                <div class="tab-content add-keywords-block" ref="addKeywordForm" v-if="currentTab === 'add'">
                    <div v-if="!isDemoPage">
                        <div class="xCard">
                            <div class="xCard__body">
                                <div class="field" id="add-keyword-list">
                                    <div class="field__title">{{ gettext('Добавить несколько фраз') }}</div>
                                    <div class="field__description">{{ gettext('Каждая фраза с новой строки') }}</div>
                                    <div class="field__input" style="margin-top: 16px">
                                        <Input v-model="addKeywordForm.addKeywordListInputValue"
                                               type="textarea"
                                               :placeholder="gettext('Список ключевых фраз')"
                                               style="min-width: 300px"
                                               :disabled="addKeywordListPending"/>
                                        <i class="field__input--pending ivu-icon ivu-icon-ios-loading ivu-load-loop" v-if="addKeywordListPending"></i>
                                        <i class="field__input--success ivu-icon ivu-icon-md-checkmark" hidden></i>
                                        <span v-if="domains.addKeywordList.query.error">{{ domains.addKeywordList.query.error }}</span>
                                    </div>
                                </div>

                                <div class="field">
                                    <button class="button button--primary" @click="submitKeywordList">{{ gettext('Добавить') }}</button>
                                </div>

                                <div class="field-response-result" v-if="addKeywordForm.addKeywordListResult" >
                                    <div style="margin-bottom: 10px">{{ gettext('Результат:') }}</div>
                                    <div v-for="item in addKeywordForm.addKeywordListResult" :key="item[0]">
                                        <strong>{{item[0]}}</strong>: <span style="text-transform: lowercase;">{{item[1]}}</span>
                                    </div>
                                </div>

                                <div class="field-error" v-if="addKeywordForm.addKeywordListError">{{addKeywordForm.addKeywordListError}}</div>
                            </div>
                        </div>

                        <div class="xCard">
                            <div class="xCard__body">
                                <div class="field">
                                    <div class="field__title">{{ gettext('Добавить файл с фразами') }}</div>
                                    <div class="field__description">
                                        <p>{{ gettext('Допустимые форматы: .xls .xlsx') }}</p>
                                        <p>{{ gettext('Заголовок столбца должен быть "Фразы" или "Phrases"') }}</p>
                                    </div>

                                    <div class="field__input" style="margin-top: 16px">
                                        <input id="add-keyword-file" type="file">
                                    </div>
                                </div>

                                <div class="field">
                                    <button class="button button--primary" @click="submitKeywordsFile">{{ gettext('Добавить') }}</button>
                                </div>

                                <div class="field-response-result" v-if="addKeywordForm.addKeywordFileResult" >
                                    <div style="margin-bottom: 2px; font-weight: 700">{{ gettext('Результат:') }}</div>
                                    <div v-for="item in addKeywordForm.addKeywordFileResult" :key="item[0]">
                                        <strong>{{item[0]}}</strong>: <span style="text-transform: lowercase;">{{item[1]}}</span>
                                    </div>
                                </div>

                                <div class="field-error" v-if="addKeywordForm.addKeywordFileError">{{addKeywordForm.addKeywordFileError}}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="add-keywords-block-is-demo">
                        <h2 class="text-center mb-4">{{ gettext('Вы находитесь в демо режиме') }}</h2>
                        <p class="mb-4">{{ gettext('Данное действие возможно только на зарегистрированном аккаунте. Зарегистрируйся сейчас и получи скидку 10%!') }}</p>
                        <p class="text-center" ><a class="btn btn-primary" href="/registration/?from_demo=1">{{ gettext('Зарегистрироваться') }}</a></p>
                    </div>
                </div>
            </template>
        </zPage>

        <Modal v-model="modal1"
               :title="gettext('Информация о разделе')"
               footer-hide>
            <div class="about-repometr">
                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Обычно пользователи ищут вашу компанию по названию или по товарам и услугам, которые вы предлагаете. Например, для кафе это будут:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('выпить кофе;') }}</li>
                            <li>{{ gettext('вкусный кофе;') }}</li>
                            <li>{{ gettext('кафе;') }}</li>
                            <li>{{ gettext('кафе поблизости.') }}</li>
                        </ul>
                    </div>
                </div>

                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Вот несколько рекомендаций относительно того, какую информацию вы можете отслеживать:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('название вашего бренда, включая варианты (кафе Андерсон);') }}</li>
                            <li>{{ gettext('категории вашего бизнеса (автосервис, автомастерская, автосервис Ford);') }}</li>
                            <li>{{ gettext('ваши товары и услуги  (замена масла, ремонт вмятин, подкачка шин).') }} </li>
                        </ul>
                    </div>
                </div>

                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Затем вы можете добавить модификаторы местоположения:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('город или район (авторемонт Красногорск, замена масла в Бутово);') }}</li>
                            <li>{{ gettext('рядом со мной (замена масла рядом).') }}</li>
                        </ul>
                    </div>
                </div>

                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Можно добавить качественные характеристики товара или услуги:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('лучшая автомастерская;') }}</li>
                            <li>{{ gettext('дешевый ремонт вмятин в Бутово;') }}</li>
                            <li>{{ gettext('быстрая замена масла рядом со мной.') }}</li>
                        </ul>
                    </div>
                </div>

                <div class="promo-block">
                    {{ gettext('Расширенный список ключевых слов вы можете попросить у вашего специалиста по SEO-продвижению или заказать у наших специалистов.') }}
                </div>

                <div class="info-block info-block--promo" :hidden=isDemoPage>
                    <div v-if="aboutRepometrFormResponse">
                        <span class="form-response">{{ aboutRepometrFormResponse.message }}</span>
                    </div>
                    <div v-else>
                        <div class="info-block__title">{{ gettext('Оставить заявку') }}</div>
                        <div class="info-block__body">
                            <form>
                                <div class="form-field">
                                    <div class="form-field__title">{{ gettext('Как к Вам обращаться?') }}</div>
                                    <Input v-model="aboutRepometrForm.name"
                                           type="text"
                                           name="name"
                                           :placeholder="gettext('Имя')"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <div class="form-field__title">{{ gettext('Укажите номер телефона или e-mail') }}</div>
                                    <Input v-model="aboutRepometrForm.phone"
                                           type="text"
                                           name="phone"
                                           :placeholder="gettext('Телефон')"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <Input v-model="aboutRepometrForm.email"
                                           type="text"
                                           name="email"
                                           :placeholder="gettext('E-mail')"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <button class="button button--primary"
                                            @click.prevent="createHelpRequest">{{ gettext('Отправить') }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>

import {handleResponse} from "@/1_webapi/response";
import {makeBaseComponent} from "@/2_app-logic/models";
import zPage from "@/3_view/core/zPage";
import {api} from "@/main";
import {Select, Option, Input} from "view-design";
import {createNamespacedHelpers} from "vuex";

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('KeywordsManagement');

export default {
    name: 'KeywordsManagement',
    components: {
        zPage,
        // zPaginator,
        Select,
        Option,
        Input,
    },
    props: {
        isDemoPage: Boolean
    },
    extends: makeBaseComponent({ mapState, mapGetters, mapActions }),
    data: () => ({
        modal1: false,
        aboutRepometrForm: {
            name: '',
            phone: '',
            email: '',
        },
        aboutRepometrFormResponse: null,
        chosenBranchId: null,
        currentTab: 'list', // list, add
        addKeywordForm: {
            addKeywordListInputValue: '',
            addKeywordListError: '',
            addKeywordListResult: '',
            file: null,
            addKeywordFileError: '',
            addKeywordFileResult: null,
        },
    }),
    watch: {
        addKeywordListSuccess: function(val, oldVal) {
            if (val) {
                const icon = this.$el.querySelector('#add-keyword-list .field__input--success')
                icon.hidden = false
            }
        },
    },
    computed: {
        ...mapState([
            'domains',
        ]),
        ...mapGetters([
            'paginator',
            'keywordsList',
        ]),
        branchesList() {
            return this.$store.getters.branchesList
        },
        pageContentState() {
            return {
                pending: true,
                isInitDataReady: !!(this.branchesList && this.branchesList.length),
                notExistText: this.gettext('Данных нет'),
            }
        },
        chosenBranchTitle() {
            return this.branchesList && this.branchesList.find(branch => {
                return this.chosenBranchId === branch.id
            })
        },
        addKeywordListPending() {
            return this.domains.addKeywordList.query.pending
        },
        addKeywordListSuccess() {
            return this.domains.addKeywordList.query.state === 'fulfilled'
        },
    },
    methods: {
        async getKeywordsList() {
            const domain = this.domains.keywordsList
            await api.keywordsManagement.fetchKeywords(domain, this.chosenBranchId)

            if (!this.keywordsList) {
                console.error('keywordsList is empty')
            }
        },
        async setBranch(chosenBranchId) {
            this.chosenBranchId = chosenBranchId
            await this.getKeywordsList()
        },
        goToLocalPackHome() {
            this.$router.push({name: 'Root'})
        },
        setCurrentTab(mode) {
            this.currentTab = mode

            setTimeout(() => {
                if (mode === 'add') {
                    this.addKeywordForm.addKeywordListInputValue = ''
                }
            })
        },
        async submitKeywordList() {
            const icon = this.$el.querySelector('#add-keyword-list .field__input--success')
            icon.hidden = true

            const data = {
                branches_id_list: [this.chosenBranchId],
                keyword_list: this.addKeywordForm.addKeywordListInputValue,
            }

            this.addKeywordForm.addKeywordListResult = null
            this.addKeywordForm.addKeywordListError = ''
            if (!data.branches_id_list.length) {
                this.addKeywordForm.addKeywordListError += this.gettext('Выберите филиал. ')
            }
            if (!data.keyword_list) {
                this.addKeywordForm.addKeywordListError += this.gettext('Введите фразы. ')
            }
            if (this.addKeywordForm.addKeywordListError) {
                return
            }

            const domain = this.domains.addKeywordList
            await api.keywordsManagement.addKeywordList(domain, data)
                .then(response => {
                    this.addKeywordForm.addKeywordListResult = handleResponse(response)
                })
                .catch(error => {
                    this.addKeywordForm.addKeywordListError = error
                })
        },
        async submitKeywordsFile() {
            const fileInput = this.$el.querySelector('#add-keyword-file')

            const data = {
                branches_id_list: [this.chosenBranchId],
                file: fileInput.files[0],
            }

            this.addKeywordForm.addKeywordFileResult = null
            this.addKeywordForm.addKeywordFileError = ''
            if (!data.branches_id_list.length) {
                this.addKeywordForm.addKeywordFileError += this.gettext('Выберите филиал. ')
            }
            if (!data.file) {
                this.addKeywordForm.addKeywordFileError += this.gettext('Выберите файл. ')
            }
            if (this.addKeywordForm.addKeywordFileError) {
                return
            }

            const domain = this.domains.addKeywordsFile
            await api.keywordsManagement.addKeywordFile(domain, data)
                .then(response => {
                    this.addKeywordForm.addKeywordFileResult = handleResponse(response)
                })
                .catch(error => {
                    this.addKeywordForm.addKeywordFileError = error
                })
        },
        async deleteKeyword(event, keywordId) {
            const target = event.target
            const cardEl = target.closest('.xCard')

            const data = {
                keywords_list: [keywordId],
            }

            const domain = this.domains.deleteKeyword
            await api.keywordsManagement.deleteKeyword(domain, data)
                .then(() => {
                    cardEl.classList.add('disabled')
                })
        },
        async openModal1() {
            this.modal1 = true
            if (!this.isDemoPage) {
                getUserDataAndFillInputs()
            }

            async function getUserDataAndFillInputs() {
                const data = await api.aboutRepometrHelpForm.getUserFormData()

                const inputs = document.querySelectorAll('.about-repometr form input')
                inputs.forEach(input => {
                    const value = data[input.name]
                    input.value = value ? value : ''
                })
            }
        },
        async createHelpRequest() {
            const data = await api.aboutRepometrHelpForm.createHelpRequest({ ...getFormValues()})
            this.aboutRepometrFormResponse = data
            function getFormValues() {
                const inputs = document.querySelectorAll('.about-repometr form input')
                const values = {}
                inputs.forEach(input => {
                    values[input.name] = input.value
                })
                return values
            }
        }
    },
    async mounted() {
        // console.log(this.$store);
    },
}
</script>



<style lang="less" scoped>
    .disabled {
        opacity: 0.3;
        pointer-events: none;
    }

    .field {
        &:nth-of-type(n+2) {
            margin-top: 20px;
        }

        .field__title {
            font-size: 14px;
        }
        .field__description {
            font-size: 12px;
            color: #777;
        }
        .field__input {
            margin-top: 10px;
        }
        .field__input--pending {
            font-size: 20px;
            vertical-align: middle;
            margin-left: 10px;
        }
        .field__input--success {
            font-size: 20px;
            vertical-align: middle;
            margin-left: 10px;
        }
        .field__number {
            font-weight: 700;
            font-size: 14px;
        }
    }

    .field-response-result {
        margin-top: 16px;
    }
    .field-error {
        margin-top: 16px;
        color: red;
    }

    .KeywordManagementPage /deep/ .tab-content {
        // "/deep/" - при <scoped> для доступа в другие компоненты
        // https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
        margin-top: 20px;
        padding: 0;
        width: 100%;
    }

    #LocalPack .KeywordManagementPage .list {
        .xCard .xCard__body {
            padding: 8px 20px;
            display: flex;
            align-items: baseline;
            width: 100%;
            justify-content: space-between;
            .__title {
                font-size: 14px;
                color: #333;
                cursor: default;
            }
        }
    }

    #LocalPack .KeywordManagementPage .add-keywords-block {
        .xCard .xCard__body {
            width: 100%;
            .field__title {
                font-size: 14px;
                color: #333;
            }
            .field__description {
                font-size: 12px;
                color: #777;
                margin-top: 4px;
            }
        }
    }

    .add-keywords-block {
        .field__input {
            margin-left: 0;
        }
    }
    .add-keywords-block-is-demo {
        font-size: 18px;
        padding: 60px;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        text-align: center;
    }
</style>